<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutter">
        <back-button returnUrl="/security/-1"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>

      <!-- TODO -->
      <div v-else>
        <b-row class="justify-content-start">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="configurationConfig.name" disabled
              :inputLabel="$t('common.nme')">
            </form-write-group-label-input>
          </b-col>
        </b-row>

        <b-row class="justify-content-start">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="configurationConfig.type" disabled
              :inputLabel="$t('common.type_label')">
            </form-write-group-label-input>
          </b-col>
        </b-row>

        <b-row class="form-group" v-if="type === 'CMS'">
          <b-col cols="6" v-if="configurationConfig.role === '0'">
            <label for="checkbox-group-1">{{ $t('common.global.verification') }}</label>
            <b-form-checkbox-group
              id="checkbox-group-1"
              :disabled="formType === 'view'"
              v-model="selectedVerif"
              stacked>
              <b-form-checkbox v-for="modeSecurity in listVerifSMIME" :key="modeSecurity.id"
                :id="'modeSecurity_' + modeSecurity.id" :disabled="modeSecurity.disabled"
                :value="modeSecurity.value" :style="modeSecurity.style">
                {{ modeSecurity.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
          <b-col cols="6" v-else>
            <label for="checkbox-group-2">{{ $t('common.global.sign') }}</label>
            <b-form-checkbox-group
              id="checkbox-group-2"
              :disabled="formType === 'view'"
              v-model="selectedVerif"
              stacked>
              <b-form-checkbox v-for="modeSecurity in listSignSMIME" :key="modeSecurity.id"
                :id="'modeSecurity_' + modeSecurity.id" :disabled="modeSecurity.disabled"
                :value="modeSecurity.value" :style="modeSecurity.style">
                {{ modeSecurity.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>

        <b-row class="form-group" v-if="type === 'SSL'">
          <b-col cols="6" v-if="configurationConfig.role === '0'">
            <label for="checkbox-group-1">{{ $t('common.global.client_remote') }}</label>
            <b-form-checkbox-group
              id="checkbox-group-1"
              :disabled="formType === 'view'"
              v-model="selectedVerif"
              stacked>
              <b-form-checkbox v-for="modeSecurity in listVerifRemoteSSL" :key="modeSecurity.id"
                :id="'modeSecurity_' + modeSecurity.id" :disabled="modeSecurity.disabled"
                :value="modeSecurity.value" :style="modeSecurity.style" >
                {{ modeSecurity.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
          <b-col cols="6" v-else>
            <label for="checkbox-group-2">{{ $t('common.global.client_local') }}</label>
            <b-form-checkbox-group
              id="checkbox-group-2"
              :disabled="formType === 'view'"
              v-model="selectedVerif"
              stacked>
              <b-form-checkbox v-for="modeSecurity in listVerifLocalSSL" :key="modeSecurity.id"
                :id="'modeSecurity_' + modeSecurity.id" :disabled="modeSecurity.disabled"
                :value="modeSecurity.value" :style="modeSecurity.style">
                {{ modeSecurity.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
          <b-col cols="6" v-if="configurationConfig.role === '0'">
            <label for="checkbox-group-2">{{ $t('common.global.server_local') }}</label>
            <b-form-checkbox-group
              id="checkbox-group-2"
              :disabled="formType === 'view'"
              v-model="selectedVerif"
              stacked>
              <b-form-checkbox v-for="modeSecurity in listVerifLocalSSL" :key="modeSecurity.id"
                :id="'modeSecurity_' + modeSecurity.id" :disabled="modeSecurity.disabled"
                :value="modeSecurity.value" :style="modeSecurity.style">
                {{ modeSecurity.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
          <b-col cols="6" v-else>
            <label for="checkbox-group-2">{{ $t('common.global.server_remote') }}</label>
            <b-form-checkbox-group
              id="checkbox-group-2"
              :disabled="formType === 'view'"
              v-model="selectedVerif"
              stacked>
              <b-form-checkbox v-for="modeSecurity in listVerifRemoteSSL" :key="modeSecurity.id"
                :id="'modeSecurity_' + modeSecurity.id" :disabled="modeSecurity.disabled"
                :value="modeSecurity.value" :style="modeSecurity.style">
                {{ modeSecurity.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-col>
        </b-row>

        <b-row class="justify-content-start">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="configurationConfig.idPod" disabled
              :inputLabel="'Pod'">
            </form-write-group-label-input>
          </b-col>
        </b-row>

        <b-row class="justify-content-start" v-if="configurationConfig.storage !== 'NONE'">
          <b-col sm="6" class="form-group">
            <label for="storage">
              {{ 'Stockage' }}<span class="color-red"> * </span>
            </label>
            <select class="form-control" v-model="configurationConfig.storage" :disabled="!canEditStorage" id="storage">
              <option value="">Veuillez sélectionner un stockage...</option>
              <option value="PEM">{{ 'PEM' }}</option>
              <option value="Volume">{{ 'Volume' }}</option>
              <option value="Vault">{{ 'Vault' }}</option>
            </select>
          </b-col>
        </b-row>


        <template v-if="configurationConfig.storage === 'PEM'">
          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.certificate" isMandatory :disabled="!canEditCertificate"
                :inputLabel="$t('common.security.certificate')"
                inputType="textarea" rows="3">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.privateKey" isMandatory :disabled="!canEditPrivateKey"
                :inputLabel="$t('common.security.priv_key')"
                inputType="textarea" rows="3">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.password" :disabled="!canEditPassword"
                :inputLabel="$t('common.pwd')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </template>

        <template v-else-if="configurationConfig.storage === 'Vault'">
          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.certificate" isMandatory :disabled="!canEditCertificate"
                :inputLabel="$t('common.security.certificate')">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.privateKey" isMandatory :disabled="!canEditPrivateKey"
                :inputLabel="$t('common.security.priv_key')">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.password" :disabled="!canEditPassword"
                :inputLabel="$t('common.pwd')">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.vaultConfigName" isMandatory :disabled="!canEditVaultConfigName"
                :inputLabel="'Vault config name'">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.vaultSecretsType" isMandatory :disabled="!canEditVaultSecretType"
                :inputLabel="'Vault secrets type'">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.vaultSecretsPath" isMandatory :disabled="!canEditVaultSecretPath"
                :inputLabel="'Vault secrets path'">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </template>

        <template v-else-if="configurationConfig.storage === 'Volume'">
          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.p12File" isMandatory :disabled="!canEditP12File"
                :inputLabel="$t('common.security.p12File')"
                inputType="text" rows="3">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group pb-3">
              <label for="var-p12-file">Variable</label>
              <b-form-radio-group v-model="configurationConfig.variableP12File" :disabled="!canEditP12FileVariable" id="var-p12-file">
                <b-form-radio name="variableP12File-radio" value="ENV">ENV</b-form-radio>
                <b-form-radio name="variableP12File-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.p12PwdFile" isMandatory :disabled="!canEditP12FilePwd"
                :inputLabel="$t('common.security.p12PwdFile')"
                inputType="text" rows="3">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group pb-3">
              <label for="var-p12-pwdfile">Variable</label>
              <b-form-radio-group v-model="configurationConfig.variableP12PwdFile" :disabled="!canEditP12File" for="var-p12-pwdfile">
                <b-form-radio name="variableP12PwdFile-radio" value="ENV">ENV</b-form-radio>
                <b-form-radio name="variableP12PwdFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>

          <b-row class="justify-content-start">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="configurationConfig.p12PwdInsideFile" isMandatory :disabled="!canEditP12FileVariable"
                :inputLabel="$t('common.security.p12PwdInsideFile')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group pb-3">
              <label for="var-p12-pwdinsfile">Variable</label>
              <b-form-radio-group v-model="configurationConfig.variableP12PwdInsideFile" :disabled="!canEditP12FilePwd" for="var-p12-pwdinsfile">
                <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
        </template>

        <template v-else></template>
      </div>

      <b-row class="justify-content-end">
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('view')">
            <span>{{ $t('common.cncl') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('edit')">
            <i class="fa-light fa-pencil"></i>
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
        </b-col>


        <!--<b-button variant="primary" v-if="!isEditable && formType !== 'add'"
          class="mx-3"
          @click="deleteCertificate">
          <i class="fa-light fa-trash"></i>
          <span>{{ $t('rights.delete') }}</span>
        </b-button>-->
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="editConfiguration">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>

        <!--<b-button variant="primary" v-if="mode === 'add'"
          class="mx-3"
          @click="createCertificate">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>-->
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import _ from 'lodash'

import backButton from "@/components/common/backButton.vue"
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'


export default {
  name: 'ConfigurationForm',
  components: {
    'back-button': backButton,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    },
    idPod: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    canEditCertificate () {
      return false && formType === 'view'
    },
    canEditPassword () {
      return false && formType === 'view'
    },
    canEditP12File () {
      return false && formType === 'view'
    },
    canEditP12FilePwd () {
      return false && formType === 'view'
    },
    canEditP12FileVariable () {
      return false && formType === 'view'
    },
    canEditPrivateKey () {
      return false && formType === 'view'
    },
    canEditStorage () {
      return false && formType === 'view'
    },
    canEditVaultConfigName () {
      return false && formType === 'view'
    },
    canEditVaultSecretPath () {
      return false && formType === 'view'
    },
    canEditVaultSecretType () {
      return false && formType === 'view'
    },
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    listSignSMIME () {
      return [
        {
          id: 'DSCA',
          text: this.$i18n.t('common.global.ctrl_CA'),
          value: '1'
        },
        {
          id: 'DSCRL',
          text: this.$i18n.t('common.global.ctrl_CRL'),
          value: '32'
        },
        {
          id: 'DSUC',
          text: this.$i18n.t('common.global.ctrl_key_usage'),
          value: '8'
        },
        // {
        //   id: 'DSTC',
        //   text: this.$i18n.t('common.global.ctrl_key_size'),
        //   value: '16'
        // },
        {
          id: 'DSEX',
          text: this.$i18n.t('common.global.ctrl_expiration'),
          value: '1024'
        },
        // {
        //   id: 'DSCN',
        //   text: this.$i18n.t('common.global.ctrl_CN'),
        //   value: '2048'
        // }
      ]
    },
    listVerifSMIME () {
      return [
        {
          id: 'VCCA',
          text: this.$i18n.t('common.global.ctrl_CA'),
          value: '2'
        },
        {
          id: 'VCCRL',
          text: this.$i18n.t('common.global.ctrl_CRL'),
          value: '256'
        },
        {
          id: 'VCUC',
          text: this.$i18n.t('common.global.ctrl_key_usage'),
          value: '64'
        },
        // {
        //   id: 'VCTC',
        //   text: this.$i18n.t('common.global.ctrl_key_size'),
        //   value: '128'
        // },
        {
          id: 'VCEX',
          text: this.$i18n.t('common.global.ctrl_expiration'),
          value: '512'
        },
        // {
        //   id: 'VCCN',
        //   text: this.$i18n.t('common.global.ctrl_CN'),
        //   value: '4096'
        // }
      ]
    },
    listVerifRemoteSSL () {
      let list = [
        {
          id: 'COCA',
          text: this.$i18n.t('common.global.verify_peer'),
          value: '1'
        },
        {
          id: 'COVC',
          text: this.$i18n.t('common.global.verify_client'),
          value: '4',
          style: 'margin-left:20px',
          disabled: !this.selectedVerif.includes('1')
        },
        {
          id: 'COVF',
          text: this.$i18n.t('common.global.verify_fail'),
          value: '4096',
          style: 'margin-left:20px',
          disabled: !this.selectedVerif.includes('1')
        },
        {
          id: 'COCRL',
          text: this.$i18n.t('common.global.ctrl_CRL'),
          value: '32',
          disabled: !this.selectedVerif.includes('1')
        },
        {
          id: 'COUC',
          text: this.$i18n.t('common.global.ctrl_key_usage'),
          value: '8',
          disabled: !this.selectedVerif.includes('1')
        },
        // {
        //   id: 'COTC',
        //   text: this.$i18n.t('common.global.ctrl_key_size'),
        //   value: '16'
        // },
        {
          id: 'COEX',
          text: this.$i18n.t('common.global.ctrl_expiration'),
          value: '1024',
          disabled: !this.selectedVerif.includes('1')
        },
        {
          id: 'COCN',
          text: this.$i18n.t('common.global.ctrl_CN'),
          value: '2048',
          disabled: !this.selectedVerif.includes('1')
        }
      ]
      return list
    },
    listVerifLocalSSL () {
      return [
        {
          id: 'LOCA',
          text: this.$i18n.t('common.global.ctrl_CA'),
          value: '2'
        },
        {
          id: 'LOCRL',
          text: this.$i18n.t('common.global.ctrl_CRL'),
          value: '256'
        },
        {
          id: 'LOUC',
          text: this.$i18n.t('common.global.ctrl_key_usage'),
          value: '64'
        },
        // {
        //   id: 'LOTC',
        //   text: this.$i18n.t('common.global.ctrl_key_size'),
        //   value: '128'
        // },
        {
          id: 'LOEX',
          text: this.$i18n.t('common.global.ctrl_expiration'),
          value: '512'
        }
      ]
    }
  },
  watch: {
    selectedVerif (val, old) {
      // supprimer toutes les options qui dépendent de verify peer
      if (old.includes('1') && !val.includes('1')) {
        this.selectedVerif = val.filter(item => !['4', '4096', '32', '8', '1024', '2048'].includes(item));
      }
    }
  },
  data () {
    return {
      activateSpinner: false,
      certificate: '',
      configurationConfig: {},
      currentConfiguration: {},
      currentVerif: [],
      formType: 'add',
      name: '',
      pageTitle: '',
      selectedVerif: []
    }
  },
  created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_config')
    if (this.id !== '-1' && (this.mode === 'view' || 'edit')) {
      this.getConfiguration()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    editConfiguration () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        name: this.configurationConfig.name,
        identifier: this.configurationConfig.identifier,
        idCertificate: this.configurationConfig.idCertificate,
        idPrivateKey: this.configurationConfig.idPrivateKey,
        modeSecurity: this.configurationConfig.modeSecurity,
        idPod: this.configurationConfig.idPod
      }
      switch (this.configurationConfig.storage) {
        case 'PEM':
          params.certificate = this.configurationConfig.certificate
          params.privateKey = this.configurationConfig.privateKey
          params.password = this.configurationConfig.password
          break
        case 'Vault':
          params.certificate = '(VAULT:' + this.configurationConfig.vaultConfigName + ':' + this.configurationConfig.certificate + ')'
          params.privateKey = '(VAULT:' + this.configurationConfig.vaultConfigName + ':' + this.configurationConfig.privateKey + ')'
          params.password = '(VAULT:' + this.configurationConfig.vaultConfigName + ':' + this.configurationConfig.password + ')'
          params.vaultConfigName = this.configurationConfig.vaultConfigName
          params.vaultSecretsType = this.configurationConfig.vaultSecretsType
          params.vaultSecretsPath = this.configurationConfig.vaultSecretsPath
          break
        case 'Volume':
          params.certificate = ''
          if (this.configurationConfig.variableP12File === 'ENV') {
            params.certificate += 'FilePath:(ENV:' + this.configurationConfig.p12File + ');'
          } else {
            params.certificate += 'FilePath:' + this.configurationConfig.p12File + ';'
          }

          if (this.configurationConfig.variableP12PwdFile === 'ENV') {
            params.certificate += 'PasswordsFilePath:(ENV:' + this.configurationConfig.p12PwdFile + ');'
          } else {
            params.certificate += 'PasswordsFilePath:' + this.configurationConfig.p12PwdFile + ';'
          }

          if (this.configurationConfig.variableP12PwdInsideFile === 'ENV') {
            params.certificate += 'JSONPasswordPath:(ENV:' + this.configurationConfig.p12PwdInsideFile + ')'
          } else {
            params.certificate += 'JSONPasswordPath:' + this.configurationConfig.p12PwdInsideFile
          }

          params.privateKey = params.certificate
          params.password = ''
          break
        case 'NONE':
          params.certificate = undefined
          params.privateKey = undefined
          params.password = undefined
          break
        default:
          params.certificate = this.configurationConfig.certificate
          params.privateKey = this.configurationConfig.privateKey
          params.password = this.configurationConfig.password
          break
      }

      let configtype = ''
      switch (this.type) {
        case 'CMS':
          configtype = 'configsmime'
          params.idConfigSMIME = this.configurationConfig.idConfigSMIME
          break
        case 'SSL':
          configtype = 'configssl'
          params.idConfigSSL = this.configurationConfig.idConfigSSL
          break
        default:
          break
      }

      let modeSecurity = 0

      for (let i = 0; i < this.selectedVerif.length; i++) {
        modeSecurity += parseInt(this.selectedVerif[i])
      }

      params.modeSecurity = modeSecurity
      this.$engine.security[configtype].edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.config_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.cert_edit_error'))
      })
    },
    formHasError () {
      if (this.configurationConfig.storage === undefined || this.configurationConfig.storage.length === 0) {
        this.okMessageBox(this.$t('common.security.storage_missing'))
        return true
      }
      switch (this.configurationConfig.storage) {
        case 'PEM':
          if (this.configurationConfig.certificate === undefined || this.configurationConfig.certificate.length === 0) {
            this.okMessageBox(this.$t('common.security.certif_desc_missing'))
            return true
          }
          if (this.configurationConfig.privateKey === undefined || this.configurationConfig.privateKey.length === 0) {
            this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
            return true
          }
          break
        case 'Vault':
          if (this.configurationConfig.certificate === undefined || this.configurationConfig.certificate.length === 0) {
            this.okMessageBox(this.$t('common.security.certif_desc_missing'))
            return true
          }
          if (this.configurationConfig.privateKey === undefined || this.configurationConfig.privateKey.length === 0) {
            this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
            return true
          }
          if (this.configurationConfig.vaultConfigName === undefined || this.configurationConfig.vaultConfigName.length === 0) {
            this.okMessageBox(this.$t('common.security.vaultConfigName_missing'))
            return true
          }
          if (this.configurationConfig.vaultSecretsType === undefined || this.configurationConfig.vaultSecretsType.length === 0) {
            this.okMessageBox(this.$t('common.security.vaultSecretsType_missing'))
            return true
          }
          if (this.configurationConfig.vaultSecretsPath === undefined || this.configurationConfig.vaultSecretsPath.length === 0) {
            this.okMessageBox(this.$t('common.security.vaultSecretsPath_missing'))
            return true
          }
          break
        case 'Volume':
          if (this.configurationConfig.p12File === undefined || this.configurationConfig.p12File.length === 0) {
            this.okMessageBox(this.$t('common.security.p12File_missing'))
            return true
          }
          if (this.configurationConfig.p12File === undefined || this.configurationConfig.p12PwdFile.length === 0) {
            this.okMessageBox(this.$t('common.security.p12Pwdfile_missing'))
            return true
          }
          if (this.configurationConfig.p12File === undefined || this.configurationConfig.p12PwdInsideFile.length === 0) {
            this.okMessageBox(this.$t('common.security.p12Pwdinsidefile_missing'))
            return true
          }
          break
        case 'NONE':
          break
        default:
          this.okMessageBox(this.$t('common.security.storage_missing'))
          return true
      }

      return false
    },
    getConfiguration () {
      let configtype = ''
      switch (this.type) {
        case 'CMS':
          configtype = 'configsmime'
          break
        case 'SSL':
          configtype = 'configssl'
          break
        default:
          break
      }
      let that = this
      let payload = {
        idPod: this.idPod
      }
      switch (this.type) {
        case 'CMS':
          payload.idConfigSMIME = this.id
          break
        case 'SSL':
          payload.idConfigSSL = this.id
          break
        default:
          break
      }
      this.$engine.security[configtype].fetch(payload)
      .then(resp => {
        let configurationsList = {}
        configurationsList = resp.data.configs
        configurationsList[0].type = that.type
        if (configurationsList[0].certificate.startsWith('(VAULT')) {
          configurationsList[0].storage = 'Vault'
          configurationsList[0].certificate = configurationsList[0].certificate.match(/\(VAULT:[^:]*:([^\)]*)/i)[1]
          configurationsList[0].privateKey = configurationsList[0].privateKey.match(/\(VAULT:[^:]*:([^\)]*)/i)[1]
          configurationsList[0].password = configurationsList[0].password.match(/\(VAULT:[^:]*:([^\)]*)/i)[1]

          configurationsList[0].variableP12File = 'ENV'
          configurationsList[0].variableP12PwdFile = 'ENV'
          configurationsList[0].variableP12PwdInsideFile = 'ENV'

        } else if (configurationsList[0].certificate.startsWith('FilePath:(')) {
          configurationsList[0].storage = 'Volume'
          configurationsList[0].p12File = configurationsList[0].certificate.match(/FilePath:\(ENV:([^\)]*)/i) !== null ? configurationsList[0].certificate.match(/FilePath:\(ENV:([^\)]*)/i)[1] : configurationsList[0].certificate.match(/FilePath:([^;]*)/i)[1]
          configurationsList[0].variableP12File = configurationsList[0].certificate.match(/FilePath:\(ENV:([^\)]*)/i) !== null ? 'ENV' : 'OTHER'
          configurationsList[0].p12PwdFile = configurationsList[0].certificate.match(/PasswordsFilePath:\(ENV:([^\)]*)/i) !== null ? configurationsList[0].certificate.match(/PasswordsFilePath:\(ENV:([^\)]*)/i)[1] : configurationsList[0].certificate.match(/PasswordsFilePath:([^;]*)/i)[1]
          configurationsList[0].variableP12PwdFile = configurationsList[0].certificate.match(/PasswordsFilePath:\(ENV:([^\)]*)/i) !== null ? 'ENV' : 'OTHER'
          configurationsList[0].p12PwdInsideFile = configurationsList[0].certificate.match(/JSONPasswordPath:\(ENV:([^\)]*)/i) !== null ? configurationsList[0].certificate.match(/JSONPasswordPath:\(ENV:([^\)]*)/i)[1] : configurationsList[0].certificate.match(/JSONPasswordPath:([^;]*)/i)[1]
          configurationsList[0].variableP12PwdInsideFile = configurationsList[0].certificate.match(/JSONPasswordPath:\(ENV:([^\)]*)/i) !== null ? 'ENV' : 'OTHER'

          configurationsList[0].certificate = ''
          configurationsList[0].privateKey = ''
        } else if (configurationsList[0].certificate.length > 0) {
          configurationsList[0].storage = 'PEM'

          configurationsList[0].variableP12File = 'ENV'
          configurationsList[0].variableP12PwdFile = 'ENV'
          configurationsList[0].variableP12PwdInsideFile = 'ENV'
        } else {
          configurationsList[0].storage = 'NONE'
        }
        that.updateConfiguration(configurationsList[0])
        that.updatemodeSecurity(configurationsList[0].modeSecurity)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    fillFields () {
      this.configurationConfig = _.cloneDeep(this.currentConfiguration)
      this.activateSpinner = false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {

      if (mode === 'view') {
        this.configurationConfig = _.cloneDeep(this.currentConfiguration)
        this.selectedVerif = _.cloneDeep(this.currentVerif)
      }
      this.formType = mode
    },
    updateConfiguration (configuration) {
      this.currentConfiguration = configuration
      this.fillFields()
    },
    updatemodeSecurity (modeSecurity) {
      this.currentVerif = []
      if (modeSecurity >= 4096) {
        modeSecurity = modeSecurity - 4096
        if (this.type === 'SSL') {
          this.currentVerif.push('4096')
        }
      }
      if (modeSecurity >= 2048) {
        modeSecurity = modeSecurity - 2048
        if (this.type === 'SSL') {
          this.currentVerif.push('2048')
        }
      }
      if (modeSecurity >= 1024) {
        modeSecurity = modeSecurity - 1024
        this.currentVerif.push('1024')
      }
      if (modeSecurity >= 512) {
        modeSecurity = modeSecurity - 512
        this.currentVerif.push('512')
      }
      if (modeSecurity >= 256) {
        modeSecurity = modeSecurity - 256
        this.currentVerif.push('256')
      }
      if (modeSecurity >= 128) {
        modeSecurity = modeSecurity - 128
        // this.currentVerif.push('128')
      }
      if (modeSecurity >= 64) {
        modeSecurity = modeSecurity - 64
        this.currentVerif.push('64')
      }
      if (modeSecurity >= 32) {
        modeSecurity = modeSecurity - 32
        this.currentVerif.push('32')
      }
      if (modeSecurity >= 16) {
        modeSecurity = modeSecurity - 16
        // this.currentVerif.push('16')
      }
      if (modeSecurity >= 8) {
        modeSecurity = modeSecurity - 8
        this.currentVerif.push('8')
      }
      if (modeSecurity >= 4) {
        modeSecurity = modeSecurity - 4
        this.currentVerif.push('4')
      }
      if (modeSecurity >= 2) {
        modeSecurity = modeSecurity - 2
        this.currentVerif.push('2')
      }
      if (modeSecurity >= 1) {
        modeSecurity = modeSecurity - 1
        this.currentVerif.push('1')
      }
      this.selectedVerif = _.cloneDeep(this.currentVerif)
    }
  }
}

</script>
